"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _jsxRuntime = require("react/jsx-runtime");
const Section = _ref => {
  let {
    customStyle,
    title,
    children
  } = _ref;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("section", {
    className: `container ${customStyle ? customStyle : ""}`,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "section_content mx-auto max-w-screen-xl py-4 px-4 sm:px-6 lg:py-16 lg:px-16 lg:my-10",
      children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("h2", {
        className: "max-w-[934px] text-center sm:mb-14",
        children: title
      }) : "", /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "max-w-full mx-auto py-12 px-4 sm:px-6 lg:py-2 lg:px-8 sm:flex sm:items-center sm:justify-center",
        children: children
      })]
    })
  });
};
var _default = Section;
exports.default = _default;